// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6870f960","513":"62c76628","703":"2570d785"}[chunkId] + ".chunk.js";
};